"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
function withHoverState(InnerComponent) {
  class Inner extends React.Component {
    constructor(props) {
      super(props);
      this.setHover = () => {
        this.setState({
          hover: true
        });
      };
      this.removeHover = () => {
        this.setState({
          hover: false
        });
      };
      this.state = {
        hover: false
      };
    }
    render() {
      return /*#__PURE__*/React.createElement(InnerComponent, Object.assign({
        isHovering: this.state.hover,
        onFocus: this.setHover,
        onBlur: this.removeHover,
        onMouseOver: this.setHover,
        onMouseOut: this.removeHover
      }, this.props));
    }
  }
  return Inner;
}
var _default = exports.default = withHoverState;